import { BaseValidatorOptions, Validator } from '@philips-internal/oswald-ui-core/lib/services/model-service';
import { FieldValidatorsName } from '../constants/validators-name-constant'

interface MaxLengthValidatorOptions extends BaseValidatorOptions {
  max?: number;
}

/**
 * The purpose of this file is to provide predefined validators that can be used within controllers
 * without duplication of code or references to hard code strings.
 *
 * Remembering that the validator inserted here must exist by default in Oswald or created in a custom way.
 */
export const PredefinedValidators = {
  argentinaCUIL,
  argentinaDNI,
  maxLength,
  required,
}

function maxLength(options: MaxLengthValidatorOptions): Validator {
  return {
    name: FieldValidatorsName.MAX_LENGTH,
    options,
  }
}

function required(options?: BaseValidatorOptions): Validator {
  return {
    name: FieldValidatorsName.REQUIRED,
    options,
  }
}

function argentinaDNI(options?: BaseValidatorOptions): Validator {
  return {
    name: FieldValidatorsName.ARGENTINA_DNI,
    options,
  }
}

function argentinaCUIL(options?: BaseValidatorOptions): Validator {
  return {
    name: FieldValidatorsName.ARGENTINA_CUIL,
    options,
  }
}